import { Attributes } from "../../shared/types/attributes.type";
import {
  Translation,
  AccommodationOccupancy,
} from "../../../gen/witbooking/backoffice/accommodation/v1/accommodation_api_pb";
import { RoomDenominationType } from "../../../gen/witbooking/backoffice/common/common_pb";
import { Image } from "../../shared/widgets/ImageManager";
import { CategoryLimitsFormData } from "../../extrasCategories/presentation/types/CategoryLimitsTypes";

export class AccommodationEntity {
  private constructor(
    public readonly id: string,
    public readonly ticker: string,
    public readonly type: RoomDenominationType,
    public readonly translationsList: Translation.AsObject[],
    public readonly active: boolean,
    public readonly multimediaList: Image[],
    public readonly occupancyCombinationsList: string[],
    public readonly accommodationBaseAdults: number = 1,
    public readonly occupancy?: AccommodationOccupancy.AsObject,
    public readonly customOccupancy?: AccommodationOccupancy.AsObject & {
      occupancyCombinationsList: string[];
    }
  ) {}

  static of(props: Attributes<AccommodationEntity>) {
    return new AccommodationEntity(
      props.id,
      props.ticker,
      props.type,
      props.translationsList,
      props.active,
      props.multimediaList,
      props.occupancyCombinationsList,
      props.accommodationBaseAdults,
      props.occupancy,
      props.customOccupancy
    );
  }
}

/**
 * What the form edits: the entity plus the synthetic `categoryLimits` property. It is not a
 * constructor field of the entity: an own `categoryLimits: undefined` key would differ from the
 * data rjsf builds, and rjsf would report that through `onChange`, marking the form as changed.
 */
export type AccommodationForm = AccommodationEntity & { categoryLimits?: CategoryLimitsFormData };
